import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createPlan } from '../services/plans.api';
import type { CreatePlanDTO } from '../types';

export function useCreatePlan() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreatePlanDTO) => createPlan(data),
    onSuccess: (plan) => {
      void queryClient.invalidateQueries({ queryKey: ['plans', 'list'] });
      void queryClient.invalidateQueries({ queryKey: ['plans', 'byProduct', plan.product_id] });
    },
  });
}
